import type { ComboboxLabels } from "@controls";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * Translated UI strings for the shared {@link Combobox} / {@link Select}
 * controls. Provided app-wide via `ControlLabelsProvider`; spread into a
 * `labels` prop only when a single call site needs to override them.
 */
export function useComboboxLabels(): Partial<ComboboxLabels> {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      selectAll: t("controls.combobox.selectAll"),
      deselectAll: t("controls.combobox.deselectAll"),
      clear: t("controls.combobox.clear"),
      selectedCount: (count) => t("controls.combobox.selected", { count }),
      more: (count) => t("controls.combobox.more", { count }),
      showLess: t("controls.combobox.showLess"),
      empty: t("controls.combobox.empty"),
      searchPlaceholder: t("controls.combobox.searchPlaceholder"),
      create: t("controls.combobox.create"),
      unavailable: t("controls.combobox.unavailable"),
      loading: t("controls.combobox.loading"),
    }),
    [t],
  );
}
